export default __webpack_public_path__ + "static/media/bg-main.7ed4670b.jpg";